import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

/**
 * Resolves a server-returned URL for use in href/src targets (PDFs, images).
 * The frontend and the backend are served on the SAME origin (ingress routes
 * `/api/*` to the backend), so we keep these paths RELATIVE. This guarantees
 * files open on the current domain (e.g. cmicmexico.org, not a stale
 * REACT_APP_BACKEND_URL host) and lets the same-origin `download` attribute
 * force a download instead of the browser opening the file in a new tab.
 */
export function absoluteUrl(maybeRelative) {
  if (!maybeRelative) return "";
  if (/^https?:\/\//i.test(maybeRelative)) return maybeRelative;
  return maybeRelative.startsWith("/") ? maybeRelative : `/${maybeRelative}`;
}

export const api = axios.create({
  baseURL: `${BACKEND}/api`,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Attach bearer token from localStorage as fallback (preview cookies cross-origin issues)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cmic_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Ocurrió un error. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
